<template>
    <div>
      <h1>IT y Desarrollo de Software</h1>
      <p>Ofrecemos soluciones innovadoras en IT y desarrollo de software.</p>
    </div>
  </template>
  
  <script>
  import { useSEO } from '@/composables/useSEO';

  export default {
    name: 'ITDesarrolloDeSoftware',
    setup() {
      useSEO({
        title: 'IT y Desarrollo de Software Industrial',
        description: 'Desarrollo de software a medida, integración de sistemas MES/ERP y soluciones IT para la industria. Frenkel Engineering conecta tecnología y operación.',
        path: '/it-desarrollo-software',
      });
    }
  };
  </script>
  
  <style scoped>
  h1 {
    text-align: justify;
    margin-top: 20px;
  }
  </style>
  